export function formatExceptionsCount(value: number): string {
  if (value >= 1000000) return ">1m";
  if (value < 10000) return String(value);
  return `${Math.floor(value / 1000)}K`;
}
